module.exports = "table {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\nth, td {\n    text-align: left;\n    padding: 8px;\n}\n\nth{\n  width:150px;\n  font-weight: normal;\n}\n\nth{\n  cursor: pointer;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/user/payment-history/payment-history.component.css
// module id = ./src/app/user/payment-history/payment-history.component.css
// module chunks = main